import * as React from 'react';
import { forwardRef } from 'react';

var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const SvgShaprLogoRound = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 56,
    height: 56,
    rx: 12,
    fill: "#1D4EFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.4554 26.4716V15.4864L32.0008 9.43652L14.2051 19.7319V33.2998L21.5463 37.5276V48.5129L32.0008 54.5627L49.7966 44.2674V30.6994L42.4554 26.4716ZM33.3452 13.0275L39.9788 16.8485V25.0388L33.3452 21.1824V13.0275ZM30.6387 50.9717L24.0051 47.1331V38.9428L30.6387 42.7991V50.9717ZM32.0008 40.6941L16.947 31.9908L32.0008 23.2875L47.037 31.9908L32.0008 40.6941Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgShaprLogoRound);

export { ForwardRef as ReactComponent };
//# sourceMappingURL=ShaprLogoRound.svg.js.map
